import { Dispatch } from 'redux';

import { setABTestValue } from 'state/ab-tests/actions';
import { AppState } from 'state/types';
import { getCurrentUser } from 'state/users/current-user/selectors';

import { AbApiExperiment } from './ab-api-experiment';

export enum AbTestHiddenWikiVariant {
  hidden = 'hidden',
  displayed = 'displayed',
}

export const hiddenWikiReduxKey = 'hiddenWiki';

export class HiddenWiki extends AbApiExperiment<AbTestHiddenWikiVariant> {
  private static enrollmentDate = new Date(2021, 3, 7);
  readonly backendKey = 'wiki';
  readonly cookieName = 'neptune-wiki';
  readonly ratio = -1; // always variantB
  readonly variantA = AbTestHiddenWikiVariant.displayed;
  readonly variantB = AbTestHiddenWikiVariant.hidden;
  readonly testDate = '202103';
  readonly test = 'hidden wiki';
  private beingTested = true;
  private readonly oldUser: boolean;
  private readonly anonymousUser: boolean;

  constructor(protected username: string | undefined, registrationDate: Date | undefined) {
    super();
    this.anonymousUser = username == null || registrationDate == null;
    this.oldUser =
      username != null && registrationDate != null && HiddenWiki.enrollmentDate > registrationDate;
  }

  static async init(getState: () => AppState, dispatch: Dispatch) {
    const user = getCurrentUser(getState());
    const test = new HiddenWiki(user?.username, user?.created);
    const variant = await test.initialize();
    setVariantToRedux(dispatch, variant);
    return test;
  }

  static isHidden(value: unknown): value is AbTestHiddenWikiVariant.hidden {
    return value === AbTestHiddenWikiVariant.hidden;
  }

  protected async obtainVariant() {
    const result = await super.obtainVariant();
    let variant = result.variant;

    if (this.oldUser) {
      variant = AbTestHiddenWikiVariant.displayed;
      this.beingTested = false;
    }

    if (this.anonymousUser && !result.variantFromCookie) {
      variant = AbTestHiddenWikiVariant.displayed;
      this.beingTested = false;
    }

    return { ...result, variant };
  }

  protected async persistVariant(
    variant: AbTestHiddenWikiVariant,
    variantFromApi?: AbTestHiddenWikiVariant,
  ) {
    if (!this.beingTested) {
      return;
    }

    await super.persistVariant(variant, variantFromApi);
  }

  protected track(variant: AbTestHiddenWikiVariant) {
    if (!this.beingTested) {
      return;
    }

    super.track(variant);
  }
}

function setVariantToRedux(dispatch: Dispatch, variant: AbTestHiddenWikiVariant) {
  dispatch(setABTestValue({ key: hiddenWikiReduxKey, value: variant }));
}
